<template>
  <v-container class="fill-height align-start">
    <userCard :mode="'view'" :user="user" />
  </v-container>
</template>

<script>
// import { UI_SNACKBAR } from '@/store/actions/ui'
import userCard from '@/components/modules/org/structure/staff/userCard.vue'
import { USER_REQUEST } from '@/store/actions/user'
export default {
  components: {
    userCard
  },
  data () {
    return {
    }
  },
  computed: {
    user: {
      get: function () {
        const profile = this.$store.getters.getProfile
        if (profile.contacts) {
          const usr = profile.userdata
          usr.CONTACTS = profile.contacts
          return usr
        } else {
          this.$store.dispatch(USER_REQUEST)
        }
        return {}
      }
    }
  },
  methods: {

  },
  created: function () {
    console.log('User profile view created (usrProfile)')
  }

}
</script>
